module.exports = __webpack_public_path__ + "img/dui.dedd9f77.png";